import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { MainService } from './mainService.service';

@Injectable()

export class CanActiveOrganizerRouteGuard implements CanActivate {
    constructor(private router: Router, private service: MainService) {}

    canActivate(): boolean {
        // console.log("tata : "+this.service.getStorage('userDetailYala'))
        if(this.service.getStorage('userDetailYala') != null) {
            let userDetailYala = JSON.parse(this.service.getStorage('userDetailYala'))
            if(userDetailYala.role == 'ORGANIZER')
                return true;
            else
                this.router.navigate(['/player/home'])
        } else {
            this.router.navigate(['/landing/login'])
            return false;
        }
    }
}



// WEBPACK FOOTER //
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/providers/can-active-organizer-route.guard.ts